import { createContext, useContext, useCallback, useMemo } from 'react';
import useEvents from '../hooks/useEvents';
import { useUser } from './UserContext';

const EventsContext = createContext();

export const EventsProvider = ({ children }) => {
  const { user } = useUser();

  const {
    events,
    loading: eventsLoading,
    error: eventsError,
    isRefreshing,
    refetch: refetchEvents,
    refresh: refreshEvents,
    updateEventInState,
    hasMore,
    loadingMore,
    loadMore
  } = useEvents(user);

  const refreshAllData = useCallback(async () => {
    try {
      await Promise.all([refreshEvents()]);
    } catch (error) {
      // Silent catch - errors are handled in useEvents
    }
  }, [refreshEvents]);

  const value = useMemo(() => ({
    events,
    eventsLoading,
    eventsError,
    isRefreshing,
    refetchEvents,
    refreshEvents,
    refreshAllData,
    updateEventInState,
    hasMore,
    loadingMore,
    loadMore
  }), [
    events,
    eventsLoading,
    eventsError,
    isRefreshing,
    refetchEvents,
    refreshEvents,
    refreshAllData,
    updateEventInState,
    hasMore,
    loadingMore,
    loadMore
  ]);

  return (
    <EventsContext.Provider value={value}>
      {children}
    </EventsContext.Provider>
  );
};

export const useEventsContext = () => {
  const context = useContext(EventsContext);
  if (!context) {
    throw new Error('useEventsContext doit être utilisé dans un EventsProvider');
  }
  return context;
};
